import NameAvatar from "./NameAvatar.vue";

export default {
  NameAvatar
};
